module.exports = __webpack_public_path__ + "assets/logos-feelgood.zip?f985e7eef593db718a08dc48348f395a";